import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { ContentPrivacyAndTerms } from "../../content.types";
import { requestUpdatePrivacyAndTerms } from "./updatePrivacyAndTerms.request";

const useUpdatePrivacyAndTerms = (
  options?: MutationOptions<ContentPrivacyAndTerms, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdatePrivacyAndTerms,
    onError: toastServerError,
    ...options
  });
};

export default useUpdatePrivacyAndTerms;
